import { render, staticRenderFns } from "./companyRegister.vue?vue&type=template&id=1be0c2d7&scoped=true&"
import script from "./companyRegister.vue?vue&type=script&lang=js&"
export * from "./companyRegister.vue?vue&type=script&lang=js&"
import style0 from "./companyRegister.vue?vue&type=style&index=0&id=1be0c2d7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be0c2d7",
  null
  
)

export default component.exports